import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers } from 'recompose'
import withYmme from 'components/common/hoc/withYmme'
import getActiveVehicle from 'selectors/getActiveVehicle'
import { getTireSizes, navigateToConfirmTireSize } from '../../actions'
import { processVehicleData } from 'components/common/hoc/withYmme/helpers'
import { YMME_NAME } from './constants'
import ShopByVehicle from './ShopByVehicle'

const withHandleSubmit = withHandlers({
  handleCustomSubmit: ({
    getTireSizes,
    navigateToConfirmTireSize,
    resetYmme,
    ymmeTireSizesParams: {
      vehicleId
    } = {},
    changeActiveTab,
    shopByTiresIndex,
    onSubmit
  }) => () => {
    onSubmit()
      .then(() => getTireSizes({
        vehicleId,
        tireSizesNotFoundModalProps: {
          onContinueClick: () => {
            resetYmme()
            changeActiveTab(shopByTiresIndex)
          },
          onCancelClick: resetYmme
        }
      }))
      .then(navigateToConfirmTireSize)
  }
})

const mapStateToProps = (state) => ({ vehicle: processVehicleData(getActiveVehicle(state)) })

export default compose(
  connect(mapStateToProps, { getTireSizes, navigateToConfirmTireSize }),
  withYmme({ name: YMME_NAME, allowMultiColumnMenu: true }),
  withHandleSubmit
)(ShopByVehicle)

export { ShopByVehicle as ShopByVehicleView }
